export enum LinkTarget {
    PARENT = '_parent',
    BLANK = '_blank',
    SELF = '_self',
    TOP = '_top'
}
